

import React from 'react';

import useRedux from 'hooks/useRedux';

import * as userManagerActions from '../home/home.duck';

import LoginPage from './components/LoginPage';
import SignUpPage from './components/SignUpPage';


const Heading = (props) => {

    const { onLoggedIn, showLogin, showCreateAccount } = props;
    const [state, actions] = useRedux(userManagerActions);
    const [viewCreateAccount, viewCreateAccount_set] = React.useState();
    const [viewLogin, viewLogin_set] = React.useState();

    const userManager = state.userManager; 

    React.useEffect(() => {
        actions.initialize();

        return ()=>{
            actions.clearLogin();
        }
    }, []);

    React.useEffect(() => {
        viewCreateAccount_set(showCreateAccount);
    }, [showCreateAccount]);

    React.useEffect(() => {
        viewLogin_set(showLogin);
    }, [showLogin]);

    return <div>
        {viewLogin && <div>
            <LoginPage {...{ userManager, actions }} handleClose={(option) => {
                if (option === 'signin') {
                    viewCreateAccount_set(true);
                    viewLogin_set(false);
                }
                else {
                    viewLogin_set(false);
                    onLoggedIn(false);

                }
            }} />
        </div>}
        {viewCreateAccount && <div>
            <SignUpPage {...{ userManager, actions }} handleClose={(option) => {
                console.log(option);

                if (option === 'login') {
                    viewCreateAccount_set(false);
                    viewLogin_set(true);
                }
                else {
                    viewCreateAccount_set(false);
                    onLoggedIn(false);
                }
            }} />
        </div>}
    </div>
}



export default Heading;




// WEBPACK FOOTER //
// ./src/login/Login.js